<template>
  <div class="text-body text-black-2 flex flex-col">
    <span v-if="links?.length">
      <RouterLink
        v-for="{ link, name, bucketRange } in [...links].sort((a, b) =>
          `${a.name}`.localeCompare(`${b.name}`),
        )"
        :key="name"
        class="group"
        :to="link"
      >
        <span>{{ name }}</span>
        <RfSegmentBucketRange
          class="segment-bucket-range"
          :showWarning="links.length > 1"
          :bucketRange="bucketRange"
        />
        <span class="group-last-of-type:hidden">, </span>
      </RouterLink>
    </span>
    <div v-else class="whitespace-pre">-</div>
    <span v-if="inherited" class="text-beige-50">
      (Inherited from <RouterLink :to="inherited.link">{{ inherited.name }}</RouterLink
      >)
    </span>
  </div>
</template>

<script setup>
import { RouterLink } from "vue-router";
import RfSegmentBucketRange from "@/components/RfSegments/RfSegmentBucketRange.vue";

defineProps({
  links: { type: Array, default: () => [] },
  inherited: { type: Object, default: null },
});
</script>

<style scoped lang="scss">
.segment-bucket-range {
  &:before {
    content: " ( ";
  }
  &:after {
    content: " ) ";
  }
}
</style>
